export default "__VITE_ASSET__BaWZV7lB__"